import { useNavigate } from 'react-router-dom'
import { useLocalizationStore } from '../../../../feature/localization/store/localization.store'
import { observer } from 'mobx-react-lite'
import { localTranslate } from '../../../../feature/localization/model/Translate'
import { AppBaseLinkKind, AppBaseLinkProps } from '../../analog/molecule/link/AppBaseLinkKind'
import { GO_BACK_DELTA } from '../../../../feature/router/util/router.constant'

export const BaseGoBackButton = observer((props: AppBaseLinkProps & { to?: string }) => {
  const navigate = useNavigate()
  const localization = useLocalizationStore()

  const { to, ...rest } = props
  const textValue = (rest as any).textValue ?? localTranslate(localization.translation.buttons.goBack)

  return (
    <AppBaseLinkKind
      onClick={() => to ? navigate(to, { replace: true }) : navigate(GO_BACK_DELTA)}
      textValue={textValue}
      {...rest}
    />
  )
})
